export default function DiscountLabel({
  width = 50,
  height = 22,
  percentage,
  ...rest
}: {
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 50 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0L0 5V17L10 22H50V0H10Z"
        fill="#FF2F2F"
      />
      <circle cx="6" cy="11" r="2" fill="white" />
      <text
        fill={"white"}
        dx="27%"
        className="text-[16px] font-500 leading-[11px]"
        x="0%"
        y="72%"
      >
        {percentage}%
      </text>
    </svg>
  );
}
